import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAuth } from '../../../hooks/useAuth';

import { AuthStatus } from '../../../provider/AuthProvider';

import { ReactComponent as Logo } from '../../../icons/logo.svg';
import { ReactComponent as Triangles } from '../../../icons/triangles.svg';

import AuthDialog from './auth-dialog/AuthDialog';
import './login.scss';

import { Button } from '../../common/button/Button';
import Form from '../../common/form/Form';
import { Input } from '../../common/input/Input';

export const Login = () => {
  const {
    formData,
    setFormData,
    loading,
    user,
    signInWithEmail,
    clearAuthError,
    authError,
    forgotPassword
  } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const memoizedIsDialogOpen = useMemo(() => {
    return (
      authError !== undefined && authError !== null && authError?.status !== AuthStatus.SUCCESS
    );
  }, [authError]);

  const redirectHome = () => {
    const from = location.state?.from || '/';
    navigate(from, { replace: true });
  };

  if (user) {
    redirectHome();
  }

  const handleSignIn = () => {
    signInWithEmail(formData?.username, formData?.password);
  };

  const handleForgotPassword = (email) => {
    forgotPassword(email);
  };

  const handleOnInputChange = (data) => {
    const { name, value } = data;
    setFormData({ ...formData, [name]: value });
  };

  return (
    <div className="login">
      <Triangles />
      <AuthDialog
        authError={authError}
        isOpen={memoizedIsDialogOpen}
        onClose={clearAuthError}
        onClick={clearAuthError}
      />
      <div>
        <div className="login__modal">
          <div>
            <Logo />
            <h1>FinTask</h1>
          </div>
          <Form
            onSubmit={loading ? () => {} : handleSignIn}
            data={formData}
            className="login__modal-content"
          >
            <div className="login__modal-title">
              <span>Welcome Back!</span>
              <span>
                Don't have an account? <span>Request Access</span>
              </span>
            </div>
            <div className="login__modal-inputs">
              <Input
                type="text"
                name="username"
                placeholder="Email"
                required
                value={formData?.username}
                onChange={handleOnInputChange}
              />
              <Input
                type="password"
                name="password"
                placeholder="Password"
                required
                value={formData?.password}
                onChange={handleOnInputChange}
              />
            </div>
            <div className="login__modal-footer">
              <Button type="submit" onClick={handleSignIn}>
                Login
              </Button>
              <span>
                Forgot Password? <span onClick={handleForgotPassword}>Click here</span>
              </span>
            </div>
          </Form>
        </div>
      </div>
      <span>COPYRIGHT @2025</span>
    </div>
  );
};
